import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }



export default /*#__PURE__*/_defineComponent({
  props: {
  value: Boolean,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, "✔️"))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, "❌"))
}
}

})